// import axios from "axios";

// import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
// const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

// export default class FeeTrackingTLM {
//   private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
//   public getAllCompanies(querySearch?: any): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .post("/api/business/company?page=0&size=10000", querySearch)
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }
//   public getBusinessCpn(): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/company-type")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }
//   public getTypeOfDispatch(): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/doc/bcdt-doc-types")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }
//   public getLicNumber(): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/cert/tlm/lic-numbers?lic-business-id=4")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }

//   public get_importers(): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/bcdt/get-importers?page=0&size=99999")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }

//   public getNetwork(): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/cert/network-type")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }

//   public LicCpnLicensee() {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/cert/lic-cpn-licenses")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }

//   public LicCpnbusinessSearch() {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .get("/api/business/cert/telcoService/businessSearch")
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }

//   public SearchTML(param: any, querySearch?: any): Promise<any> {
//     let url = "/api/business/track-debt/tlm?page=" + param.page + "&size=" + param.size;
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .post(url, querySearch)
//         .then((res) => {
//           resolve(res);
//         })
//         .catch((err) => {
//           console.log(reject(err));
//         });
//     });
//   }

//   public SumSearchTML(querySearch?: any): Promise<any> {
//     let url = "/api/business/track-debt/tlm/total-fee";
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .post(url, querySearch)
//         .then((res) => {
//           resolve(res);
//         })
//         .catch((err) => {
//           console.log(reject(err));
//         });
//     });
//   }

//   public excelTlm(querySearch?: any): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .post("/api/business/track-debt/tlm/excel", querySearch, { responseType: "blob" })
//         .then((res) => {
//           resolve(res);
//         })
//         .catch((err) => {
//           console.log(reject(err));
//         });
//     });
//   }
// }

import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class FeeTrackingTLM {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company?page=0&size=10000", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/doc/bcdt-doc-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/tlm/lic-numbers?lic-business-id=4")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public get_importers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/bcdt/get-importers?page=0&size=99999")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnLicensee() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-cpn-licenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnbusinessSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchTML(querySearch: any, cancelToken): Promise<any> {
    let url = "/api/business/track-debt/tlm";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public SumSearchTML(querySearch?: any): Promise<any> {
    let url = "/api/business/track-debt/tlm/total-fee";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelTlm(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/track-debt/tlm/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
